import clsx from 'clsx'
import React from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { CloseIcon } from '@/components/icons/close-icon'

import * as styles from './Modal.css'

const ModalRoot = DialogPrimitive.Root

const ModalTrigger = DialogPrimitive.Trigger

const ModalPortal = DialogPrimitive.Portal

const ModalClose = DialogPrimitive.Close

const ModalOverlay = React.forwardRef<
	React.ElementRef<typeof DialogPrimitive.Overlay>,
	React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => (
	<DialogPrimitive.Overlay ref={ref} className={clsx(styles.overlay, className)} {...props} />
))

ModalOverlay.displayName = 'ModalOverlay'

const ModalContent = React.forwardRef<
	React.ElementRef<typeof DialogPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ className, children, ...props }, ref) => (
	<ModalPortal>
		<ModalOverlay />
		<DialogPrimitive.Content
			ref={ref}
			className={clsx(styles.modalContent, className)}
			aria-describedby="modal-content"
			{...props}>
			{children}
			<DialogPrimitive.Close className={styles.modalClose}>
				<CloseIcon className={styles.closeIcon} />
			</DialogPrimitive.Close>
		</DialogPrimitive.Content>
	</ModalPortal>
))

ModalContent.displayName = 'ModalContent'

const ModalHeader = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
	<div className={clsx(styles.modalHeader, className)} {...props} />
)
ModalHeader.displayName = 'ModalHeader'

const ModalFooter = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
	<div className={clsx(styles.modalFooter, className)} {...props} />
)

ModalFooter.displayName = 'ModalFooter'

const ModalTitle = React.forwardRef<
	React.ElementRef<typeof DialogPrimitive.Title>,
	React.ComponentPropsWithoutRef<typeof DialogPrimitive.Title>
>(({ className, ...props }, ref) => <DialogPrimitive.Title ref={ref} className={clsx(className)} {...props} />)

ModalTitle.displayName = 'ModalTitle'

export {
	ModalRoot,
	ModalPortal,
	ModalTrigger,
	ModalClose,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalTitle
}
